import { observer } from 'mobx-react'
import React from 'react'
import FinancialSourceAccordio from '../../../../components/customElements/RequestDataAccordions/FinancialSourceAccordio'
import RightDrawer from '../../../../components/customElements/RightDrawer/RightDrawer'
import { DrawerTitle } from '../../../SingleRequestPage/components/SingleRequestDrawer/SingleRequestDrawer'
import { RequestType } from '../../../SingleRequestPage/types/Request.type'
import { newRequestDrawerStore } from '../../stores/NewRequestDrawerStore'
import ActionButtons from './components/ActionButtons'
import FinishClarifying from './components/FinishClarifying'
import InstallationDataAndFinishBtn from './components/InstallationDataAndFinishBtn'
import NewCommentsAcc from './components/NewCommentsAcc'
import NewCustomerDataAcc from './components/NewCustomerDataAcc'
import NewHasDuplicates from './components/NewHasDuplicates'
import NewRequestInfoAcc from './components/NewRequestInfoAcc'
import StartInstallation from './components/StartInstallationAcc'
import StatusAndDuplicateUnit from './components/StatusAndDuplicateUnit'
import ToDuplicateNew from './components/ToDuplicateNew'
import ToImpossibleNew from './components/ToImpossibleNew'
import ToReworkNew from './components/ToReworkNew'

const NewRequestDrawer = () => {
  const { isOpen, closeDrawer, request, mode, onBack } = newRequestDrawerStore

  return (
    <RightDrawer
      backButtonClick={onBack}
      loading={false}
      onClose={closeDrawer}
      onTop={() => {}}
      open={isOpen}
      title={<DrawerTitle title={`Заявка № ${request?.id}`} hidSubtitle />}
      titleComp={''}
      isReportDetailsOpen={false}
    >
      {request && (
        <>
          {mode === 'default' && (
            <>
              <StatusAndDuplicateUnit request={request} />
              <NewRequestInfoAcc request={request} />
              <NewCustomerDataAcc request={request} />
              {showDuplicates(request) && (
                <NewHasDuplicates request={request} />
              )}
              {/* @ts-ignore */}
              <FinancialSourceAccordio data={request} />
              {showStartInstallation(request) && (
                <StartInstallation request={request} />
              )}
              {showInstallationData(request) && (
                <InstallationDataAndFinishBtn request={request} />
              )}

              <NewCommentsAcc request={request} />
              {showEndClarifying(request) && (
                <FinishClarifying request={request} />
              )}
              <ActionButtons request={request} />
            </>
          )}
          {mode === 'duplicate' && <ToDuplicateNew request={request} />}
          {mode === 'impossible' && <ToImpossibleNew request={request} />}
          {mode === 'to-rework' && <ToReworkNew request={request} />}
        </>
      )}
    </RightDrawer>
  )
}

const showDuplicates = (request: RequestType) =>
  ([2, 4, 6, 14].includes(request.status) ||
    (request.status === 14 && request.dataCheckingStatus === 3)) &&
  request.dealer === request.authorId

const showStartInstallation = (request: RequestType) =>
  [4].includes(request.status)
const showInstallationData = (request: RequestType) =>
  [5, 6, 7, 11, 12, 13, 14, 15, 16].includes(request.status)

// const showComments = (request: RequestType) =>
//   [6, 7, 11, 12, 13, 14, 15].includes(request.status)
const showEndClarifying = (request: RequestType) =>
  [14].includes(request.status) ||
  (request.status === 6 && request.dataCheckingStatus === 2)

export default observer(NewRequestDrawer)
